/**
 * Formata valor numérico com vírgula como separador decimal e 2 casas decimais
 */
export const formatDecimal = (v) => {
  if (v === null || v === undefined || isNaN(Number(v))) return '-';
  return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};


export const formatCurrencyBR = (value, real = false) => {
  if (value === null || value === undefined || isNaN(Number(value))) return '-';
  let options = {}
  if (real) {
    options = {
      style: 'currency',
      currency: 'BRL',
    }
  }
  return (Number(value) / 100).toLocaleString('pt-BR', {
    ...options,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * Formata um percentual já na escala 0-100 (ex.: 22.5 → "22,50%"). Diferente de
 * formatCurrencyBR, não divide por 100 — o valor não é dinheiro em centavos.
 */
export const formatPercentBR = (value) => {
  if (value === null || value === undefined || isNaN(Number(value))) return '-';
  return `${Number(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}%`;
};

/**
 * Formata data para dd/mm/yyyy. Se `comHora` for true, formata como dd/mm/yyyy HH:mm.
 * Sem `comHora`, usa o recorte literal da string ISO (evita shift de timezone em datas
 * "puras"); com `comHora`, usa Date local (necessário para extrair a hora corretamente).
 */
export const formatDateOnlyBr = (value, comHora = false) => {
  if (!value) return '-';
  if (!comHora && typeof value === 'string') {
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  }
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '-';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const dataFormatada = `${day}/${month}/${year}`;
  if (!comHora) return dataFormatada;
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${dataFormatada} ${hours}:${minutes}`;
};
